<template>
  <div>
    <!-- Page Header -->
    <Header
      :topHeader="$t('leave.overView')"
      :headerText="$t('leave.header')"
    />

    <div class="row no-gutters mr-md-4 mt-md-3 ml-md-1">
      <div class="col-12 col-md-12">
        <div :class="['card', 'leave-main-card', 'pb-md-5']">
          <create
            :subHeading="$t('leave.subHeading')"
            :modalName="'medical-leave'"
            @name="searchByName"
            @typeChange="fetchLeaves"
          />

          <table-data
            :fields="fields"
            :data="filteredLeaves"
            :notificationField="false"
            @showLeave="singleLeave"
            @removeLeave="removeLeave"
          />

          <medical-leave @updateArray="fillLeaves" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/shared/header';
import Create from '@/components/leave/CreateLeave';
import TableData from '@/components/leave/TableData';
import MedicalLeave from '@/components/modals/medicalLeave';

export default {
  components: {
    Header,
    Create,
    TableData,
    MedicalLeave,
  },

  data() {
    return {
      fields: [
        'employeName',
        'fromDate',
        'endDate',
        'leaveType',
        'comments',
        'edit',
        'delete',
      ],
      leaves: [],
      filteredLeaves: [],
    };
  },

  mounted() {
    this.fetchLeaves();
  },

  methods: {
    fetchLeaves(type) {
      this.$services.medicalLeave.showLeaves(type).then((res) => {
        this.leaves = res.data;
        this.filteredLeaves = this.leaves;
      });
    },

    searchByName(name) {
      let leaves = [];
      leaves = this.leaves.filter(l =>
        l.employee.firstName.toLowerCase().match(name.toLowerCase()) ||
          l.employee.firstName.toLowerCase().match(name.toLowerCase()) ||
          l.employee.lastName.toLowerCase().match(name.toLowerCase()) ||
          l.employee.lastName.toLowerCase().match(name.toLowerCase()));
      this.filteredLeaves = leaves;
    },

    fillLeaves(leave) {
      if (leave.edit) {
        const leaves = [];
        this.filteredLeaves.forEach((l) => {
          if (l.reference != leave.reference) {
            leaves.push(l);
          } else {
            leaves.push(leave);
          }
        });
        this.filteredLeaves = leaves;
      } else {
        this.filteredLeaves.push(leave);
      }
    },

    singleLeave(leave) {
      this.$root.$emit('medicalLeave', leave);
      this.$modal.show('medical-leave');
    },

    removeLeave(reference) {
      let leaves = [];
      this.$services.medicalLeave.deleteLeave(reference).then((res) => {
        if (res.status == 200) {
          this.$miniToastr.success(this.$t('global.deleteToaster'));
          leaves = this.filteredLeaves.filter(l => l.reference != reference);
        } else {
          this.$miniToastr.error(this.$t('global.nodeleteToaster'));
        }
        this.filteredLeaves = leaves;
      });
    },
  },
};
</script>
<style>
.leave-main-card {
  @media (min-width: 320px) and (max-width: 600px) {
    width: 90%;
    margin: 0 auto;
    height: auto;
  }
}
</style>
